import { render, staticRenderFns } from "./memberPrepaidPhoneButton.vue?vue&type=template&id=be1442a8&scoped=true&"
import script from "./memberPrepaidPhoneButton.vue?vue&type=script&lang=js&"
export * from "./memberPrepaidPhoneButton.vue?vue&type=script&lang=js&"
import style0 from "./memberPrepaidPhoneButton.vue?vue&type=style&index=0&id=be1442a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1442a8",
  null
  
)

export default component.exports